import api from "../index";

export const GetAllAccountApi = (params) => api.get(`admin/getall-vertex-account?${params}`);
export const V2fxRequestAcceptRejectApi = (data) => api.post('admin/vertex-account-approve-reject', data);
export const GetAllV2fxAccountByIdApi = (terminalID) => api.get(`trading/get-account-byid/${terminalID}`);